export const CATEGORY_LABELS = {
  NMG: 'Naming Conventions',
  DBP: 'Design Best Practices',
  MRD: 'Maintainability & Readability',
  USG: 'Usage',
  ANA: 'Project Anatomy',
  PRR: 'Performance & Reusability',
  REL: 'Reliability',
  SEC: 'Security'
};

export const CATEGORY_COLORS = {
  NMG: '#0ea5e9',
  DBP: '#22c55e',
  MRD: '#f59e0b',
  USG: '#8b5cf6',
  ANA: '#14b8a6',
  PRR: '#f97316',
  REL: '#ef4444',
  SEC: '#6366f1',
  OTHER: '#94a3b8'
};

export const CATEGORY_ORDER = ['NMG', 'DBP', 'MRD', 'USG', 'ANA', 'PRR', 'REL', 'SEC', 'OTHER'];

export const getCategoryFromCode = (errorCode) => {
  if (!errorCode || typeof errorCode !== 'string') {
    return 'OTHER';
  }

  const match = errorCode.match(/ST-([A-Z]{3})-/);
  if (match && CATEGORY_LABELS[match[1]]) {
    return match[1];
  }

  return 'OTHER';
};

export const getCategoryLabel = (errorCode) => {
  const category = getCategoryFromCode(errorCode);
  return CATEGORY_LABELS[category] || 'Other';
};

export const getIssueCategory = (issue) => getCategoryFromCode(issue?.errorCode);
